import axios from 'axios';

const addGroup = (accessToken, group) => {
  const data = { group };
  return axios({ method: 'post', url: '/user/api/v1/groups', headers: getHeader(accessToken), data });
};

const getGroups = (accessToken) => {
  return axios({ method: 'get', url: '/user/api/v1/groups', headers: getHeader(accessToken) });
};

const getMemberInfo = (accessToken) => {
  return axios({ method: 'get', url: '/user/api/v1/members', headers: getHeader(accessToken) });
};

const getHeader = (accessToken) => {
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` };
};

export { addGroup, getGroups, getMemberInfo };
